// Keep in sync with Acme\UserCss\CssSanitizer::MAX_LENGTH.
// This is only for the UI counter; the real limit is enforced server-side.
export const MAX_LENGTH = 4000;
